export enum ActualDataType {
    Float,
    Digital,
    Timestamp,
    String
}
